import { isWebinarId } from '@core/shared';
import { OptionsApi } from '@core/swagger-client/src/OptionsApi';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$webinarId')({
    beforeLoad: async ({ params, context }) => {
        if (!isWebinarId(params.webinarId)) {
            throw redirect({ to: '/not-found' });
        }
    },
    loader: async ({ params, context }) => {
        const webinar = context.queryClient.ensureQueryData(OptionsApi.webinar.get(params.webinarId, { staleTime: 60_000 }));
        await Promise.all([webinar]);
        // The webinar also feeds the document title (DocumentTitle in apps/frontend).
        return { webinarId: params.webinarId, webinar: await webinar };
    }
});
